import { api } from "./api";

const actions = {
	/**
	 * Get news categories for a specific assistant
	 * @param {string} assistantID - Assistant ID
	 * @param {Function} onSuccess - Callback function on success
	 * @param {Function} onFailure - Callback function on failure
	 * @returns {Function} - Dispatch function
	 */
	getNewsCategories: function (assistantID, onSuccess = () => {}, onFailure = () => {}) {
		return dispatch => {
			dispatch(
				api({
					type: "cockpits/getNewsCategories",
					url: `/api/v1/getNewsCategories/${assistantID}`,
					method: "POST",
					data: {
						currentTS: new Date().getTime()
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Get news for a specific assistant
	 * @param {string} assistantID - Assistant ID
	 * @param {number} limit - Number of news items to fetch
	 * @param {number} skip - Number of news items to skip
	 * @param {Function} onSuccess - Callback function on success
	 * @param {Function} onFailure - Callback function on failure
	 * @returns {Function} - Dispatch function
	 */
	getNews: function (
		assistantID,
		limit = 20,
		skip = 0,
		onSuccess = () => {},
		onFailure = () => {}
	) {
		return dispatch => {
			dispatch(
				api({
					type: "cockpits/getNews",
					url: `/api/v1/getNews/${assistantID}`,
					method: "POST",
					data: {
						currentTS: new Date().getTime(),
						limit,
						skip
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Check for unread news
	 * @param {string} assistantID - Assistant ID
	 * @param {number} lastCheckedNewsTS - Last checked news timestamp
	 * @param {Function} onSuccess - Callback function on success
	 * @param {Function} onFailure - Callback function on failure
	 * @returns {Function} - Dispatch function
	 */
	checkForUnreadNews: function (
		assistantID,
		lastCheckedNewsTS,
		onSuccess = () => {},
		onFailure = () => {}
	) {
		return dispatch => {
			dispatch(
				api({
					type: "cockpits/checkForUnreadNews",
					url: `/api/v1/checkForUnreadNews/${assistantID}`,
					method: "POST",
					data: {
						currentTS: new Date().getTime(),
						lastCheckedNewsTS
					},
					onSuccess,
					onFailure
				})
			);
		};
	}
};

export default actions;
